import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEInfoViewItemView from './oe-info-view-item-view';
import {OEMediaViewerContentType, OEMediaViewerContent, OEMediaViewerDataSourceIntrinsic} from '../../media-viewer/oe-media-viewer-model';
import OEMediaViewerController from '../../media-viewer/oe-media-viewer-controller';
import retardUpdate from '../../../lib/react/update-retarder';

export default class OEInfoViewItemMedia extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.plyrInstances = {}

        this.state = {
            strings: {
                title: 'Media'
            },
            media: []
        };

        this.updateLanguage = this.updateLanguage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.content !== this.props.content)    {
            this.updateLocalizedContent(nextProps.content);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLocalizedContent(content)    {
        if(!this.oe.isReady()) return;
        content = content || this.props.content;
        let si = this.oe.sharedInterface;

        let media = !content ? null : content.map((src) => si.getLocalizedStringEnc(src));
        this.setState({media: media});
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({ strings: {
            title: si.getLocalizedStringEnc('info_view_media_label')
        }});

        this.updateLocalizedContent();
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
        });
    }

    render() {
        let videos = !this.state.media ? null : this.state.media.map((src, index) =>
            <div key={index} className="video-container">
                <OEMediaViewerController
                    className="info-media-viewer"
                    dataSource={new OEMediaViewerDataSourceIntrinsic(
                        new OEMediaViewerContent(
                            OEMediaViewerContentType.video,
                            index == 0 ? '/media-ut/zeiss/uvprotect.mp4' : '/media-ut/zeiss/blaufilter.mp4',
                            false, null, null, null, true
                        )
                    )}
                    showControlsWhenWindow={true}
                    showNextPrevButtons={false}
                    shouldChangePrev={this.shouldChange}
                    shouldChangeNext={this.shouldChange}
                />
            </div>
        );

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEInfoViewItemView
                    moduleId={this.props.moduleId}
                    elementRef={this.props.elementRef}
                    isMaximizeable={true}
                    isMaximized={this.props.isMaximized}
                    notMinimizeable={this.props.notMinimizeable}
                    hasSeparator={this.props.hasSeparator}
                    className="ivi-media"
                    title={this.state.strings.title}
                    onToggle={this.props.onToggle}
                    onAnimFinished={this.props.onAnimFinished}
                >
                    <div className="media-container">
                        {videos}
                    </div>
                </OEInfoViewItemView>
            </React.Fragment>
        );
    }

    shouldChange()  {
        return false;
    }
}

OEInfoViewItemMedia.defaultProps = {
    moduleId: '',
    elementRef: '',
    isMaximized: false,
    notMinimizeable: false,
    hasSeparator: true
};

OEInfoViewItemMedia.propTypes = {
    moduleId: PropTypes.string,
    isMaximized: PropTypes.bool,
    notMinimizeable: PropTypes.bool,
    hasSeparator: PropTypes.bool
};